import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { notification } from "../services";

import {
  activateFreePlan,
  buyBusinessPlan,
  buyGrowthPlan,
  buyEnterprisePlan
} from "../services/plan";

class Plans extends Component {
  state = {
    plan1InProgress: false,
    plan2InProgress: false,
    plan3InProgress: false,
    plan4InProgress: false
  };

  onActivateFree = async token => {
    this.setState({
      plan1InProgress: true
    });
    try {
      let response = await activateFreePlan(token);
      notification.success(response.data.message);
      console.log(response);
    } catch (err) {}
    this.setState({
      plan1InProgress: false
    });
  };

  onBuyBusinessPlan = async token => {
    this.setState({
      plan2InProgress: true
    });
    try {
      let response = await buyBusinessPlan(token);
      console.log(response);
    } catch (err) {}
    this.setState({
      plan2InProgress: false
    });
  };

  onBuyGrowthPlan = async token => {
    this.setState({
      plan3InProgress: true
    });
    try {
      let response = await buyGrowthPlan(token);
      console.log(response);
    } catch (err) {}
    this.setState({
      plan3InProgress: false
    });
  };

  onBuyEnterprisePlan = async token => {
    this.setState({
      plan4InProgress: true
    });
    try {
      let response = await buyEnterprisePlan(token);
      console.log(response);
    } catch (err) {}
    this.setState({
      plan4InProgress: false
    });
  };

  render() {
    return (
      <div className="main-content">
        <div className="container-main">
          <div style={{ width: "100%", height: "100%" }}>
            <section className="pricing py-5">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-3 pricing-card">
                    <div className="card mb-5 mb-lg-0">
                      <div className="card-body">
                        <h5 className="card-title text-muted text-uppercase text-center">
                          Free
                        </h5>
                        <h6 className="card-price text-center">$0</h6>
                        <br />
                        <h6 className="text-center">User / Month</h6>
                        <hr />
                        <ul className="fa-ul">
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            <strong>Up to 2 documents</strong>
                          </li>
                        </ul>

                        <a
                          href="https://app.photoncommerce.com/sign-up"
                          className="btn btn-block btn-primary text-uppercase"
                        >
                          {this.state.plan2InProgress
                            ? "Activating..."
                            : "Activate"}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 pricing-card">
                    <div className="card mb-5 mb-lg-0">
                      <div className="card-body">
                        <h5 className="card-title text-muted text-uppercase text-center">
                          Business
                        </h5>
                        <h6 className="card-price text-center">$9.99</h6>
                        <br />
                        <h6 className="text-center">User / Month</h6>
                        <hr />
                        <ul className="fa-ul">
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            <strong>Up to 20 documents a month</strong>
                          </li>
                        </ul>

                        <a
                          href="https://app.photoncommerce.com/sign-up"
                          className="btn btn-block btn-primary text-uppercase"
                        >
                          {this.state.plan2InProgress
                            ? "Activating..."
                            : "Get Started"}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 pricing-card">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title text-muted text-uppercase text-center">
                          Growth
                        </h5>
                        <h6 className="card-price text-center">$39.99</h6>
                        <br />
                        <h6 className="text-center">User / Month</h6>
                        <hr />
                        <ul className="fa-ul">
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            <strong>Up to 100 documents a month</strong>
                          </li>
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            Support within 3 hours
                          </li>
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            Basic integrations
                          </li>
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            Expert supervision
                          </li>
                        </ul>
                        <a
                          href="https://app.photoncommerce.com/sign-up"
                          className="btn btn-block btn-primary text-uppercase"
                        >
                          {this.state.plan2InProgress
                            ? "Activating..."
                            : "Get Started"}
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 pricing-card">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title text-muted text-uppercase text-center">
                          ENTERPRISE
                        </h5>
                        <h6 className="card-price text-center">Custom</h6>
                        <hr />
                        <ul className="fa-ul">
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            <strong>> 100 documents a month</strong>
                          </li>
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            Live support
                          </li>
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            Integrations
                          </li>
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            Expert supervision
                          </li>
                          <li>
                            <span className="fa-li">
                              <i className="fas fa-check"></i>
                            </span>
                            Guarantees
                          </li>
                        </ul>

                        <a
                          href="https://app.photoncommerce.com/sign-up"
                          className="btn btn-block btn-primary text-uppercase"
                        >
                          {this.state.plan2InProgress
                            ? "Activating..."
                            : "Get Started"}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Plans);
